const TextMessengerSvg = ({
   width = 33,
   height = 33,
   fill = 'white',
}: {
   width?: number
   height?: number
   fill?: string
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 33 33"
      fill="none"
   >
      <path
         d="M18.3429 14.4815C18.3429 15.6012 17.4341 16.5099 16.3145 16.5099C15.1948 16.5099 14.2861 15.6012 14.2861 14.4815C14.2861 13.3618 15.1948 12.4531 16.3145 12.4531C17.4341 12.4531 18.3429 13.3618 18.3429 14.4815ZM23.0758 12.4531C21.9561 12.4531 21.0474 13.3618 21.0474 14.4815C21.0474 15.6012 21.9561 16.5099 23.0758 16.5099C24.1955 16.5099 25.1042 15.6012 25.1042 14.4815C25.1042 13.3618 24.1955 12.4531 23.0758 12.4531ZM9.55315 12.4531C8.43347 12.4531 7.52475 13.3618 7.52475 14.4815C7.52475 15.6012 8.43347 16.5099 9.55315 16.5099C10.6728 16.5099 11.5815 15.6012 11.5815 14.4815C11.5815 13.3618 10.6728 12.4531 9.55315 12.4531ZM32.5417 5.69178V21.919C32.5417 24.9021 30.1157 27.328 27.1326 27.328H23.2759L18.0724 31.6282C17.5842 32.0637 16.9582 32.2827 16.3253 32.2827C15.6816 32.2827 15.0339 32.0555 14.5173 31.5971L9.44767 27.328H5.495C2.5119 27.328 0.0859375 24.9021 0.0859375 21.919V5.69178C0.0872898 2.70868 2.51325 0.282715 5.49635 0.282715H27.1326C30.1157 0.282715 32.5417 2.70868 32.5417 5.69178ZM29.8371 5.69178C29.8371 4.20023 28.6241 2.98725 27.1326 2.98725H5.49635C4.0048 2.98725 2.79182 4.20023 2.79182 5.69178V21.919C2.79182 23.4105 4.0048 24.6235 5.49635 24.6235H9.9426C10.2604 24.6235 10.57 24.7357 10.8148 24.9413L16.2888 29.5525L21.9291 24.9332C22.1711 24.733 22.4754 24.6235 22.7905 24.6235H27.1339C28.6255 24.6235 29.8385 23.4105 29.8385 21.919L29.8371 5.69178Z"
         fill={fill}
      />
   </svg>
)

export default TextMessengerSvg
